import { Helmet } from "react-helmet";
import Footer from "../../common/Footer";
import Header from "../../common/Header";
import Section from "../../common/Section";
import { useState } from "react";
import { Link } from "react-router-dom";
import Icons from "./sub/Icons";


function SolutionsPage() {

    const [active, setActive] = useState("1");

    return (
        <div className="customer-stories">
            <Header location="other" />
            <Helmet>
                <title>Turgoil - Lahendused</title>
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1.0, user-scalable=no"
                />
            </Helmet>
            <Section backgroundColor="white">
                <div className="solutionsPage">
                    <div className="line1">LAHENDUSED</div>
                    <div className="line2">Vali endale sobiv ostumudel</div>
                    <div className="line3">Alusta sealt, kus täna oled. Kasvada saad koos Turgoiliga.</div>
                    <div className="line4">
                        <div className="switch">
                            <div className={`active-side ${active === "2" ? "right" : ""}`} />

                            <button onClick={() => { setActive("1") }}>
                                Kuutasu
                            </button>

                            <button onClick={() => setActive("2")}>
                                Aastas säästad kaks kuutasu
                            </button>
                        </div>


                    </div>

                    <div className="line5">
                        <div className="card">
                            <div>{Icons.Document}</div>
                            <div className="cardLine1">Hange</div>
                            <div className="cardLine2" style={{ height: '52px' }}>Sina juhid kogu ostuprotsessi.</div>
                            <div className="cardLine3" style={{ color: '#DB9E21' }}>0 €</div>
                            <div className="cardLine4">kuu</div>
                            <div className="cardLine5">
                                <div>{Icons.CheckYellow}</div>
                                <div>Piiramatu arv hankeid</div>
                            </div>
                            <div className="cardLine5">
                                <div>{Icons.CheckYellow}</div>
                                <div>Turuhinna ülevaade</div>
                            </div>
                            <div className="cardLine5">
                                <div>{Icons.CheckYellow}</div>
                                <div>Statistika ja aruanded</div>
                            </div>
                            <div className="cardLine5" style={{ paddingBottom: '72px' }}>
                                <div>{Icons.CheckYellow}</div>
                                <div>Hangete kopeerimine</div>
                            </div>
                            <Link
                                to="/oil-requests/create"
                                style={{ width: '100%', textDecoration: "none", color: "inherit" }}
                            >
                                <div className="buttonYellow">
                                    Alusta tasuta
                                </div>
                            </Link>
                        </div>
                        <div className="card">
                            <div>{Icons.Bell}</div>
                            <div className="cardLine1">Automatiseeritud ost</div>
                            <div className="cardLine2" style={{ height: '52px' }}>Süsteem valmistab ostu ette. Sina kinnitad.</div>
                            <div className="cardLine3" style={{ color: '#1A273D' }}> {active === "1" && (19)} {active === "2" && (190)} €</div>
                            <div className="cardLine4">/mahuti {active === "1" && ("/kuu")} {active === "2" && ("/aasta")}</div>
                            <div className="cardLine5">
                                <div>{Icons.CheckDark}</div>
                                <div>Kõik hange paketi võimalused</div>
                            </div>
                            <div className="cardLine5">
                                <div>{Icons.CheckDark}</div>
                                <div>Mahutite automaatne jälgimine</div>
                            </div>
                            <div className="cardLine5">
                                <div>{Icons.CheckDark}</div>
                                <div>Hanke automaatne käivitamine</div>
                            </div>
                            <div className="cardLine5">
                                <div>{Icons.CheckDark}</div>
                                <div>Pakkumiste automaatne kogumine</div>
                            </div>
                            <div className="cardLine5" style={{ paddingBottom: '35px' }}>
                                <div>{Icons.CheckDark}</div>
                                <div>Realajas ülevaade ja teavitused</div>
                            </div>
                            <Link
                                to="/contact"
                                style={{ width: '100%', textDecoration: "none", color: "inherit" }}
                            >
                                <div className="button">
                                    Broneeri demo
                                </div>
                            </Link>
                        </div>
                        <div className="card">
                            <div>{Icons.Settings}</div>
                            <div className="cardLine1">Täisautomaatne ost</div>
                            <div className="cardLine2" style={{ height: '52px' }}>Süsteem juhib kogu ostuprotsessi vastvalt sinu seadistusele.</div>
                            <div className="cardLine3" style={{ color: '#4F9F5E' }}>{active === "1" && ("39 € + ")} {active === "2" && ("390 € + ")}  <span style={{fontSize: '20px'}}>0.10 s/l</span></div>
                            <div className="cardLine4">teenustasu automaatselt ostetud kütusele</div>
                            <div className="cardLine5">
                                <div>{Icons.CheckGreen}</div>
                                <div>Kõik automatiseeritud ostuvõimalused</div>
                            </div>
                            <div className="cardLine5">
                                <div>{Icons.CheckGreen}</div>
                                <div>Automaatne tarnija valik</div>
                            </div>
                            <div className="cardLine5">
                                <div>{Icons.CheckGreen}</div>
                                <div>Automaatne tellimuse kinnitamine</div>
                            </div>
                            <div className="cardLine5">
                                <div>{Icons.CheckGreen}</div>
                                <div>Minimaalse sekkumisega ostuprotsess</div>
                            </div>
                            <div className="cardLine5" style={{ paddingBottom: '35px' }}>
                                <div>{Icons.CheckGreen}</div>
                                <div>Prioriteetne tugi</div>
                            </div>
                            <Link
                                to="/contact"
                                style={{ width: '100%', textDecoration: "none", color: "inherit" }}
                            >
                                <div className="buttonGreen">
                                    Broneeri demo
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="line6">Hind kehtib ühe mahuti kohta. Kõik hinnad on ilma käibemaksuta. <br /> Kuutasu rakendub ainult aktiivsetel kuudel.</div>

                    <div className="line7">Võrdle funktsioone</div>
                    <div className="line8">
                        <img src="images/svg/compare_functions.svg" alt="compare-functions"
                            style={{
                                maxWidth: "100%",
                                height: "auto",
                                display: "block",
                            }} />
                        <Link to="/contact" className="buttonBlack">
                            <div>Võta ühendust</div>
                        </Link>

                    </div>

                </div>
            </Section>

            <Footer rootFolder="../../../" />
        </div>
    );
}
export default SolutionsPage;
